import React, { useState } from 'react';
import Button from '../../UI/Button/Button';
import './floorMap.css'
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';
const ModalFloorMap = ({ setIsModalActive }) => {
    const [inputValue1, setInputValue1] = useState('');
    const [inputValue2, setInputValue2] = useState('');
    const handleNoClick = () => {
        setIsModalActive(false);
        
    };
    const handleInputChange1 = (e) => {
        setInputValue1(e.target.value);
    };

    const handleInputChange2 = (e) => {
        setInputValue2(e.target.value);
    };

    const handleButtonClick = () => {
        handleNoClick();
        axiosInstance.post('website/buildings', {
            name: inputValue1,
            floor_amount: inputValue2
        })
        .then(response => {
            window.location.reload()
        })
        .catch(error => {
            logger.error(error);
        });
    };

    return (
        <div className='floorMap'>
            <p>Добавление помещений</p>
            <input className='floorMapInput' type="text" placeholder='Название' value={inputValue1} onChange={handleInputChange1} />
            <input className='floorMapInput' type="text" placeholder='Количество этажей' value={inputValue2} onChange={handleInputChange2} />
            <Button className="createBuilding" onClick={handleButtonClick} text="Добавить" />
        </div>
    );
};

export default ModalFloorMap;
